import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountByIdController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountByIdController.php
* @route '/api/bank-account/{bank_account}'
*/
const GetBankAccountByIdController = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBankAccountByIdController.url(args, options),
    method: 'get',
})

GetBankAccountByIdController.definition = {
    methods: ["get","head"],
    url: '/api/bank-account/{bank_account}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountByIdController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountByIdController.php
* @route '/api/bank-account/{bank_account}'
*/
GetBankAccountByIdController.url = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { bank_account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { bank_account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            bank_account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        bank_account: typeof args.bank_account === 'object'
        ? args.bank_account.id
        : args.bank_account,
    }

    return GetBankAccountByIdController.definition.url
            .replace('{bank_account}', parsedArgs.bank_account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountByIdController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountByIdController.php
* @route '/api/bank-account/{bank_account}'
*/
GetBankAccountByIdController.get = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBankAccountByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountByIdController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountByIdController.php
* @route '/api/bank-account/{bank_account}'
*/
GetBankAccountByIdController.head = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetBankAccountByIdController.url(args, options),
    method: 'head',
})

export default GetBankAccountByIdController